export enum TipoPaginadorEnum {
  online= 'online',
  offline = 'offline',
}
